/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} FollowersInputs */

const th_followers = /** @type {(inputs: FollowersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ผู้ติดตาม`)
};

const en_followers = /** @type {(inputs: FollowersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Following`)
};

const ja_followers = /** @type {(inputs: FollowersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォロー中`)
};

const zh_followers = /** @type {(inputs: FollowersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关注中`)
};

const es_followers = /** @type {(inputs: FollowersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siguiendo`)
};

const pt_followers = /** @type {(inputs: FollowersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguindo`)
};

const id_followers = /** @type {(inputs: FollowersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diikuti`)
};

const fr_followers = /** @type {(inputs: FollowersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suivis`)
};

const tl_followers = /** @type {(inputs: FollowersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sinusundan`)
};

const vi_followers = /** @type {(inputs: FollowersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang theo dõi`)
};

const ko_followers = /** @type {(inputs: FollowersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`팔로잉`)
};

const de_followers = /** @type {(inputs: FollowersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Folge ich`)
};

const ru_followers = /** @type {(inputs: FollowersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подписки`)
};

const tr_followers = /** @type {(inputs: FollowersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Takip edilenler`)
};

const it_followers = /** @type {(inputs: FollowersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguiti`)
};

const pl_followers = /** @type {(inputs: FollowersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obserwowane`)
};

const uk_followers = /** @type {(inputs: FollowersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Підписки`)
};

const hi_followers = /** @type {(inputs: FollowersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ॉलो किए गए`)
};

const ar_followers = /** @type {(inputs: FollowersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المتابَعون`)
};

const ms_followers = /** @type {(inputs: FollowersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diikuti`)
};

const bn_followers = /** @type {(inputs: FollowersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অনুসৃত`)
};

const zh_tw2_followers = /** @type {(inputs: FollowersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`追蹤中`)
};

const zh_hk2_followers = /** @type {(inputs: FollowersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`追蹤中`)
};

const ur_followers = /** @type {(inputs: FollowersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فالو شدہ`)
};

const fa_followers = /** @type {(inputs: FollowersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دنبال‌شده`)
};

const sw_followers = /** @type {(inputs: FollowersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unafuatilia`)
};

const nl_followers = /** @type {(inputs: FollowersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gevolgd`)
};

/**
* | output |
* | --- |
* | "Following" |
*
* @param {FollowersInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const followers = /** @type {((inputs?: FollowersInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<FollowersInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_followers(inputs)
	if (locale === "ja") return ja_followers(inputs)
	if (locale === "zh") return zh_followers(inputs)
	if (locale === "es") return es_followers(inputs)
	if (locale === "pt") return pt_followers(inputs)
	if (locale === "id") return id_followers(inputs)
	if (locale === "fr") return fr_followers(inputs)
	if (locale === "tl") return tl_followers(inputs)
	if (locale === "vi") return vi_followers(inputs)
	if (locale === "ko") return ko_followers(inputs)
	if (locale === "de") return de_followers(inputs)
	if (locale === "ru") return ru_followers(inputs)
	if (locale === "tr") return tr_followers(inputs)
	if (locale === "it") return it_followers(inputs)
	if (locale === "pl") return pl_followers(inputs)
	if (locale === "uk") return uk_followers(inputs)
	if (locale === "hi") return hi_followers(inputs)
	if (locale === "ar") return ar_followers(inputs)
	if (locale === "ms") return ms_followers(inputs)
	if (locale === "bn") return bn_followers(inputs)
	if (locale === "zh-TW") return zh_tw2_followers(inputs)
	if (locale === "zh-HK") return zh_hk2_followers(inputs)
	if (locale === "ur") return ur_followers(inputs)
	if (locale === "fa") return fa_followers(inputs)
	if (locale === "sw") return sw_followers(inputs)
	if (locale === "nl") return nl_followers(inputs)
	return en_followers(inputs)
});